import Loader from "../../../../shared/components/Loader";

const Subjects = ({
  subjects,
  handleSelectSubject,
  selectedSubject,
  subjectLoading,
  action,
  closeSideModal,
}) => {
  if (action !== "show-subjects") return null;

  return (
    <div className="bg-white pb-4 rounded-md">
      <h5 className="text-independence text-base mb-5">Class Subjects</h5>

      {subjectLoading ? <Loader /> : null}

      <div>
        {!subjectLoading &&
          subjects?.map((subject, i) => (
            <div
              key={i}
              className={`flex items-center px-3 mb-3 h-12 rounded-sm cursor-pointer ${
                selectedSubject?.classSubjectId === subject?.classSubjectId
                  ? "bg-primary"
                  : "bg-cultured "
              }`}
              onClick={() => handleSelectSubject(subject)}
            >
              <p
                className={`text-sm font-semibold capitalize ${
                  selectedSubject?.classSubjectId === subject?.classSubjectId
                    ? "text-white"
                    : "text-yankee_blue"
                }`}
              >
                {subject?.name}
              </p>
            </div>
          ))}

        <p
          className="text-center text-coral_red mt-1 py-3 cursor-pointer"
          onClick={closeSideModal}
        >
          Cancel
        </p>
      </div>
    </div>
  );
};
export default Subjects;
